import { render, staticRenderFns } from "./PaisFilterBar.vue?vue&type=template&id=0f2c693b"
import script from "./PaisFilterBar.vue?vue&type=script&lang=js"
export * from "./PaisFilterBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports